
import React from 'react';

import SubHeading from '../SubHeading/SubHeading';
import './Membership.css';

const Membership = () => (
  <div className="app__membership">
    <div className="app__membership-heading">
      <SubHeading title="For Your Consideration" />
      <h1 className="headtext__cormorant">Regal Membership</h1>
      <p className="p__opensans">Become a Platinum or Diamond Member today for exclusive perks!</p>
    </div>
    <div className="app__membership-input flex__center">
      <input type="email" placeholder="Enter your email address" />
      <button type="button" className="custom__button">Inquire Today</button>
    </div>
  </div>
);

export default Membership;